import React, { useEffect } from 'react';

//Components.
import AllVideosComponent from '../../all-videos/AllVideosComponent';
import ActiveChallengeComments from './comments/activeChallengeCommentsForm/ActiveChallengeComments';
import ShowComments from './comments/showCommentsComponent/ShowComments';

//Dependencies.
import { useNavigate, useParams } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';

//Functions.
import { updateActiveChallengeInFS, updateVideoInFS } from '../../../functions/firebase/firestore';

import moment from 'moment';

//Functions.
  //Slices.
  import { useDispatch, useSelector } from 'react-redux';
  //Selectors.
  import { allActiveChallenges, transferChallenge, updateChallenge } from '../../../slices/challengesSlice';
  import { allVideos as videos, updateFSvideoData, } from '../../../slices/allVideosSlice';
  import { loggedInUser } from '../../../slices/allUsersSlice';
  
import "./ActiveChallengeDetails.styles.css";
import { deleteDoc, doc, setDoc } from 'firebase/firestore';
import { db } from '../../../databases/firebase';


const ActiveChallengeDetails = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const activeChallenges = useSelector(allActiveChallenges);
  const challengeObject = activeChallenges[params._challengeID];
  const loggedInAs = useSelector(loggedInUser);

  let {
    activeChallengeProperties,
    activeChallengeProperties:
    {
      activeChallengeComments,
      activeChallengeDaysRemaining,
      activeChallengeEndDate,
      description,
      endActiveChallenge,
      howWillActiveChallengeEnd,
      title,
      winner,
      winningVotes
    },
    challengeVideos,
    coverImageDetails: { imageLink, source },
    _challengeID,
    _ownerID,
  } = activeChallenges[params._challengeID];

  const voteTotal = Object.values(activeChallenges[params._challengeID].challengeVideos)
    .map(val => val.votes)
    .reduce((a, b) => a + b); //Every time someone casts a vote, voteTotal changes (increases by one).

  useEffect(() => {
    if (howWillActiveChallengeEnd === "winning votes is reached.") {
      const checkForWinner = Object.values(activeChallenges[params._challengeID].challengeVideos)
        .filter(val => val.votes == winningVotes).forEach(winningVideo => {
          let updateWins = winningVideo.record.wins + 1;
          const updateWinPct = updateWins / (updateWins + winningVideo.record.losses + winningVideo.record.ties);
          const updateWinnersRecord = { ...winningVideo.record, wins: updateWins, winPct: updateWinPct };

          const payload = { _videoID: winningVideo._videoID, _newKey: "record", _newValue: { ...updateWinnersRecord } };
          
          dispatch(updateFSvideoData({ ...payload }));

          activeChallengeProperties = {
            ...activeChallengeProperties,
            endActiveChallenge: true, //sets endActiveChallenge to true.
            winner: {
              [winningVideo._videoID]: { ...winningVideo, winner: true } //adds the winning video to winner: { }.
            }
          };

          dispatch(updateChallenge({ type: 'allActiveChallenges', key: _challengeID, value: { ...activeChallenges[params._challengeID], activeChallengeProperties } }));
        }) //If the resulting array's length > 1, then there is a winner.
    }
    
    return () => {

    };
  }, [voteTotal])

  useEffect(() => {
    return () => {
      if (endActiveChallenge) {
        const payload = {
          key: _challengeID,
          value: {
            _challengeID,
            _ownerID,
            challengeVideos,
            coverImageDetails: { imageLink, source },
            activeChallengeProperties: { title, winner, description }
          },
          oldType: "allActiveChallenges",
          newType: "completedChallenges"
        };
        
        const checkForLosers = Object.values(activeChallenges[params._challengeID].challengeVideos)
        .filter(val => Number(val.votes) !== Number(winningVotes)).forEach(losingVideo => {
          const updatedLosses = losingVideo.record.losses + 1;
          const updatedWinPct = (losingVideo.record.wins) / (losingVideo.record.wins + updatedLosses);
          const updatedLosingVideoRecord = { ...losingVideo.record, losses: updatedLosses, winPct: updatedWinPct }; 

          const payload = { _videoID: losingVideo._videoID, _newKey: "record", _newValue: { ...updatedLosingVideoRecord } };

          // dispatch(updateVideo({ ...payload })); //replaced with updateFSvideoData below.
          dispatch(updateFSvideoData({ ...payload }));
        }); //Moved checkForLosers from inside useEffect( [voteTotal]) to inside this if (endActiveChallenge) { ... } conditional.

        const completedChallengePromise = new Promise((res, rej) => {
          dispatch(transferChallenge({ ...payload }));
          res({ ...payload });
          rej({ message: "Oops... something went wrong while trying to sent challenge to completed challenge!!!", payload });
        });

        Promise.all(
          [
            completedChallengePromise, //Transfer challenge to 'completed' in Redux.
            setDoc(doc(db, "internet-idol-faceoff", "Challenges", "completedChallenges", _challengeID), { ...payload.value }), //Add to 'completedChallenges' in FS.
            deleteDoc(doc(db, "internet-idol-faceoff", "Challenges", "activeChallenges", _challengeID)) //Delete completed challenge in FS 'activeChallenges'.
          ]
        )
          .then(successMessage => {
            console.log({ message: "YEAH!!! Successfully transferred challenge inside Redux, added new completed challengea AND deleted active challenge!!!", successMessage });
          })
          .catch(error => console.error({ message: "Oops... something went wrong with Promise.all() in trying to transfer challenge. Please check Firebase or Redux.", error, errorCode: error.code, errorMessage: error.message }))
      }
    }
  }, [endActiveChallenge]);

  return (
    <div style={{overflow: 'hidden'}}>
      <Row style={{maxWidth: '100%', display: 'flex', justifyContent: 'center'}} className='py-5'>
        <Col>
          <h1 style={{textAlign: 'center'}}>Details for <span className='text-danger'>{title}</span></h1>
        </Col>
      </Row>
      <Container>
        <h3 style={{ textAlign: "center" }}>LEADER BOARD</h3>
        {
          Object.values(challengeVideos)
            .sort((a, b) => b.votes - a.votes)
            .map((val, ind, arr) => (
              <div className='my-1 p-1' style={{border: '1.5px solid black', backgroundColor: arr.length > 1 ? ((ind === 0) && (arr[0].votes > arr[1].votes)) ? "bisque" : "whitesmoke" : "lightseagreen"}} key={val._videoID}>
                <h5>_videoID: {val._videoID}.</h5>
                <h5>title: {val.title}.</h5>
                <h5>votes: {val.votes}.</h5>
              </div>
            ))
        }
      </Container>
      <Container>
        <h1>_challengeID: {_challengeID}.</h1>
        <h3>challenge owner (_ownerID): {_ownerID}.</h3>
        <h3>description: {description}.</h3>
        <h3>howWillActiveChallengeEnd: {howWillActiveChallengeEnd}.</h3>
        {
          howWillActiveChallengeEnd === "end date is reached."
          &&
          <h3>This challenge ends on: <span className='text-danger' style={{backgroundColor: "lightyellow"}}>{activeChallengeEndDate}</span>  ({activeChallengeDaysRemaining} days remaining)</h3>
        }

        {
          howWillActiveChallengeEnd === "winning votes is reached."
          &&
          <h3>This challenge <em>ends</em> with the first video getting <span className='text-danger' style={{backgroundColor: "lightyellow"}}>{winningVotes}</span> votes.</h3>
        }
        
      </Container>
      <h1 style={{ textAlign: 'center' }}>CHALLENGE VIDEOS:</h1>
      <AllVideosComponent challengeVideos={challengeVideos} />
      <div>
        {
          loggedInAs._userID && <ActiveChallengeComments />
        }        
        
        <Container className='activeChallengeContainer'>
          <Row>
            <Col style={{textAlign: 'center'}}><h1 style={{color: 'whitesmoke'}}>COMMENTS:</h1></Col>
          </Row>
          {
            challengeObject.activeChallengeProperties?.activeChallengeComments.length > 0
            &&
            <ShowComments />
          }
        </Container>
        
      </div>
    </div>
  )
}

export default ActiveChallengeDetails;

